module.exports = __webpack_public_path__ + "img/tit_bj.3ea2c968.png";